var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from "vue-property-decorator";
import axios from "axios";
let WorkStepList = class WorkStepList extends Vue {
    jobs = [];
    search = '';
    dia = false;
    workstep = [];
    page = [];
    text = '';
    filter = [];
    color = "";
    snackbar = false;
    timeout = 5000;
    loading = true;
    worktype = [];
    CreateDia = false;
    item = {
        work_type: "",
        name: "",
        date: "",
        description: "",
        control: false
    };
    options = {
        itemsPerPage: 20,
        page: 1,
        total: 0
    };
    workstepcreate = {
        work_type: {
            id: 0,
            type: "",
        },
        name: "",
        job: {
            id: 0,
            order_nr: ""
        },
        date: "",
        description: "",
        control: false
    };
    workstepedit = {
        work_type: "",
        name: "",
        date: "",
        description: "",
        control: false
    };
    headers = [
        { text: 'Auftragsnummer', value: 'job', align: 'start', sortable: true },
        { text: 'Arbeitsart', value: 'work_type', sortable: true },
        { text: 'Datum', value: 'date', sortable: true },
        { text: 'Bearbeiter', value: 'name', sortable: true },
        { text: 'Beschreibung', value: 'description', sortable: true },
        { text: 'Aktionen', value: 'actions' },
    ];
    getWorklogs() {
        this.loading = true;
        this.setFilter('search', this.search);
        axios.get('/api/worklog', {
            params: {
                itemsPerPage: this.options.itemsPerPage,
                page: this.options.page,
                sortBy: this.options.sortBy,
                sortDesc: this.options.sortDesc,
                filter: this.filter,
            }
        }).then((response) => {
            this.workstep = response.data.data;
            this.page = response.data.meta;
            this.loading = false;
        });
        return this.workstep;
    }
    openDia(item) {
        this.item = item;
        this.workstepedit.work_type = item.work_type;
        this.workstepedit.name = item.name;
        this.workstepedit.date = item.date;
        this.workstepedit.description = item.description;
        this.workstepedit.control = item.control;
        this.dia = true;
    }
    setFilter(key, value) {
        this.clearFilterByKey(key);
        if (value != -1 || value != '-1') {
            this.filter.push({ key: key, value: value });
        }
    }
    clearFilterByKey(key) {
        for (let i = 0; i < this.filter.length; i++) {
            if (this.filter[i].key == key) {
                this.filter.splice(i, 1);
            }
        }
        return false;
    }
    saveCreate() {
        axios.put('/api/worklog/worklog/create', { workstep: this.workstepcreate }).then((response) => {
            this.CreateDia = false;
            this.text = "Der Arbeitschritt wurde erstellt.";
            this.color = "green";
            this.snackbar = true;
            this.clear();
            this.getJobList();
            this.getWorklogs();
            this.getWorktype();
        }).catch((error) => {
            this.text = "Der Arbeitschritt konnte nicht angelegt werden.";
            this.color = "red";
            this.snackbar = true;
        });
        this.snackbar = false;
    }
    saveEdit() {
        this.item.work_type = this.workstepedit.work_type;
        this.item.name = this.workstepedit.name;
        this.item.date = this.workstepedit.date;
        this.item.description = this.workstepedit.description;
        this.item.control = this.workstepedit.control;
        axios.put('/api/worklog/' + this.item.id, { workstep: this.item }).then((response) => {
            this.text = "Der Arbeitschritt wurde verändert.";
            this.color = "green";
            this.snackbar = true;
            this.dia = false;
            this.clear();
        }).catch((error) => {
            this.text = "Der Arbeitschritt konnte nicht verändert werden.";
            this.color = "red";
            this.snackbar = true;
        });
        this.snackbar = false;
    }
    clear() {
        this.item = {
            work_type: "",
            name: "",
            date: "",
            description: "",
            control: false
        };
        this.workstepedit = {
            work_type: "",
            name: "",
            date: "",
            description: "",
            control: false
        };
        this.workstepcreate = {
            work_type: {
                id: 0,
                type: "",
            },
            name: "",
            job: {
                id: 0,
                order_nr: ""
            },
            date: "",
            description: "",
            control: false
        };
    }
    filterOnlyLowerText(value, search, item) {
        return value != null &&
            search != null &&
            typeof value === 'string' &&
            value.toString().toLocaleLowerCase().indexOf(search) !== -1;
    }
    getWorktype() {
        axios.get('/api/worktype').then((response) => {
            this.worktype = response.data.data;
        });
        return this.worktype;
    }
    getJobList() {
        axios.get('/api/jobs', {}).then((response) => {
            this.jobs = response.data.data;
        });
        return this.jobs;
    }
    watchOptions() {
        this.getJobList();
        this.getWorklogs();
        this.getWorktype();
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.getJobList();
            this.getWorklogs();
            this.getWorktype();
            this.$store.state.monitor = false;
        }
        else {
            this.$router.push('/login');
        }
    }
};
__decorate([
    Watch('options', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], WorkStepList.prototype, "watchOptions", null);
WorkStepList = __decorate([
    Component({
        name: "WorkStepList",
    })
], WorkStepList);
export default WorkStepList;
